import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/filing-review/creators/{creatorId}/configs']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const createCreatorConfig = async ({ creatorId, ...body }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/filing-review/creators/{creatorId}/configs', { creatorId });
  const response = await noodleApiClient.post(path, body);
  return response.data;
};

export default createCreatorConfig;
